import React from 'react'

const SimpleImageTest: React.FC = () => {
  const testImages = [
    '/images/questions/De_test_Ebook3_q11_img3_4acdc6.png',
    '/images/questions/De_test_Ebook3_q12_img4_5bdce7.png',
    '/images/questions/sample_question_image_1.png',
    '/images/questions/sample_explanation_image_1.png'
  ]

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Simple Image Test</h1>
      
      <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded">
        <h2 className="font-semibold mb-2">Test Info</h2>
        <p className="text-sm">Testing image loading from <code>/images/questions/</code> directory</p>
        <p className="text-sm">Images should be accessible at: <code>http://localhost:3000/images/questions/filename.png</code></p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {testImages.map((imagePath, index) => (
          <div key={index} className="border border-gray-300 rounded-lg p-4">
            <h3 className="font-medium mb-2">Test Image {index + 1}</h3>
            <p className="text-sm text-gray-600 mb-3">Path: <code>{imagePath}</code></p>
            
            <div className="border border-gray-200 p-2 rounded bg-gray-50">
              <img
                src={imagePath}
                alt={`Test image ${index + 1}`}
                className="max-w-full h-auto mx-auto block"
                onLoad={() => {
                  console.log(`✅ Image loaded: ${imagePath}`)
                }}
                onError={(e) => {
                  console.error(`❌ Failed to load: ${imagePath}`)
                  const target = e.currentTarget as HTMLImageElement
                  target.style.display = 'none'
                  
                  const errorDiv = document.createElement('div')
                  errorDiv.className = 'text-center text-red-500 py-8 bg-red-50 rounded border border-red-200'
                  errorDiv.innerHTML = `
                    <div class="text-lg mb-2">❌ Image Load Failed</div>
                    <div class="text-sm">${imagePath}</div>
                  `
                  target.parentNode?.appendChild(errorDiv)
                }}
              />
            </div>
            
            {/* Direct link test */}
            <div className="mt-3">
              <a 
                href={imagePath} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-500 hover:text-blue-700 text-sm underline"
              >
                🔗 Open image directly
              </a>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded">
        <h3 className="font-semibold mb-2">🔧 Troubleshooting</h3>
        <ul className="text-sm space-y-1">
          <li>• Check if files exist in <code>public/images/questions/</code></li>
          <li>• Verify file permissions and names match exactly</li>
          <li>• Open browser dev tools to see network requests</li>
          <li>• Try accessing images directly via URL</li>
        </ul>
      </div>
    </div>
  )
}

export default SimpleImageTest